import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "checked", "disabled", "value", "onInput"]
const _hoisted_2 = ["for", "onClick", "onKeyup"]

import { useGettext } from 'vue3-gettext'

interface Props {
  inline?: boolean,
  containerClass?: string,
  disabled?: boolean,
  options?: PushButtonsOption[],
  modelValue?: string | number | boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PushButtons',
  props: {
    inline: { type: Boolean, default: true },
    containerClass: { default: '' },
    disabled: { type: Boolean, default: false },
    options: { default: undefined },
    modelValue: { type: [String, Number, Boolean], default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;

const { $gettext } = useGettext()



const defaultOptions: PushButtonsOption[] = [
  {
    label: $gettext('Yes'),
    value: true,
  },
  {
    label: $gettext('No'),
    value: false,
  },
]

const pushButtonOptions = props.options || defaultOptions




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["radio-container", [_ctx.containerClass, { inline: _ctx.inline }]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pushButtonOptions), (option) => {
      return (_openBlock(), _createElementBlock("div", {
        key: option.label,
        class: _normalizeClass([
        'push-button',
        { checked: _ctx.modelValue === option.value },
      ])
      }, [
        _createElementVNode("input", _mergeProps({
          id: `${option.label}-${option.value}`,
          type: "radio",
          checked: _ctx.modelValue === option.value,
          disabled: _ctx.disabled,
          value: option.value
        }, _ctx.$attrs, {
          onInput: ($event: any) => (emit('update:modelValue', option.value))
        }), null, 16, _hoisted_1),
        _createElementVNode("label", {
          for: `${option.label}-${option.value}`,
          onClick: _withModifiers(($event: any) => (!_ctx.disabled && emit('update:modelValue', option.value)), ["prevent"]),
          onKeyup: _withModifiers(($event: any) => (!_ctx.disabled && emit('update:modelValue', option.value)), ["prevent"])
        }, _toDisplayString(option.label), 41, _hoisted_2)
      ], 2))
    }), 128))
  ], 2))
}
}

})